/**
 * Role checks against the logged-in user.
 *
 * <p>Every one of these must survive there being NO user. The 401 interceptor clears the session the
 * moment the API rejects a request, and it does that while pages are mid-render — so a component that
 * asks "is this an accountant?" a tick later used to throw "can't access property userRole, user is
 * null" and leave an uncaught error behind the redirect to /login. Nobody is any role when nobody is
 * signed in, so the honest answer to all of them is false.</p>
 */
class UserUtil {
    currentRole() {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            return user && user.userRole ? user.userRole : '';
        } catch (e) {
            return '';   // malformed entry — treat as signed out rather than break the page
        }
    }

    isSuperAdmin() {
        return this.currentRole() === 'SUPER_ADMIN';
    }

    isEmployee() {
        return this.currentRole() === 'EMPLOYEE';
    }

    isAccountant() {
        return this.currentRole() === 'ACCOUNTANT';
    }
}

export default new UserUtil();
